import request from '../request';

// 保存标签
export const labelSave = (query) => {
  return request({
    url: '/api/zgsource_manage/label/save',
    method: 'post',
    data: query,
  });
};

// 标签列表
export const getQuestionLabelList = (query) => {
  return request({
    url: '/api/zgsource_manage/label/list',
    method: 'post',
    data: query,
  });
};

// 删除标签
export const delQuestionLabel = (query) => {
  return request({
    url: '/api/zgsource_manage/label/delete',
    method: 'post',
    data: query,
  });
};

// 标签详情
export const questionLabelDetail = (query) => {
  return request({
    url: '/api/zgsource_manage/label/detail',
    method: 'post',
    data: query,
  });
};

// 标签详情
export const labelQueList = (query) => {
  return request({
    url: '/api/zgsource_manage/question/list',
    method: 'post',
    data: query,
  });
};

// 标签详情
export const labelQuestionList = (query) => {
  return request({
    url: '/api/zgsource_manage/question/questionFind',
    method: 'post',
    data: query,
  });
};

// 试题列表
export const questionList = (query) => {
  return request({
    url: '/api/zgsource_manage/question/questionFind',
    method: 'post',
    data: query,
  });
};

// 抽题
export const autoSelQuestion = (query) => {
  return request({
    url: '/api/zgsource_manage/question/selectQuestion',
    method: 'post',
    data: query,
  });
};

// 标签列表（下拉）
export const questionLabelOption = (query) => {
  return request({
    url: '/api/zgsource_manage/label/list4Select',
    method: 'get',
    data: query,
  });
};
